import type { ReactNode } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import {
  CleaningJobPanel,
  type CleaningJobPanelParts,
  type CleaningJobPanelProps,
} from '@/components/cleaning/job-panel'

/**
 * One cleaning job in a centred dialog, opened from a row of the cleaning
 * board (CAP-418).
 *
 * The body - every action, the state, the timeline - is `CleaningJobPanel`,
 * shared with the side sheet on the property calendar (CAP-875). All that is
 * left here is the dialog around it.
 */

// The dialog scrolls as a whole, so the body needs no wrapper of its own.
const DIALOG_PARTS: CleaningJobPanelParts = {
  Header: DialogHeader,
  Title: DialogTitle,
  Body: ({ children }: { children: ReactNode }) => <>{children}</>,
}

interface JobDrawerProps extends Omit<CleaningJobPanelProps, 'parts'> {
  onClose: () => void
}

export function CleaningJobDrawer({ onClose, ...panel }: JobDrawerProps) {
  return (
    <Dialog open onOpenChange={open => !open && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto">
        <CleaningJobPanel {...panel} parts={DIALOG_PARTS} />
      </DialogContent>
    </Dialog>
  )
}
